import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { Observable } from "rxjs";
import { getBackgroundImageStyles } from "src/app/shared/functions/ng-style-utils";
import type { Swiper } from "swiper";
import { contentListItem } from "../util";

@Component({
    selector: "app-mini-slider",
    templateUrl: "./mini-slider.component.html",
    styleUrls: ["./mini-slider.component.scss"],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class MiniSliderComponent {
  @Input() items: Observable<contentListItem[]>;
  swiper: Swiper;

  constructor(private cdr: ChangeDetectorRef) {}

  onSwiper(ev: CustomEvent) {
    this.swiper = ev.detail[0];
    this.swiper.on("slideChange", () => this.cdr.detectChanges());
  }
  navigateTo(i: number) {
    this.swiper.slideTo(i);
  }
  getImgStyle(url) {
    return url?.length > 0
      ? getBackgroundImageStyles(0.1, url)
      : { background: "#ddd" };
  }
}
